module.exports = __webpack_public_path__ + "static/media/X_ACH.c1cb83ba.svg";